import './sass/styles.scss';

import * as bootstrap from 'bootstrap';

/**
 * Instantiate Modal Block for BootStrap 5.
 */
import ModalBlock from "./blocks/modal.js";
new ModalBlock(bootstrap);
